import React from 'react'

const Intakes = () => {
  return (
    <div>Intakes</div>
  )
}

export default Intakes